<template>
  <div class="m-5 md:m-15 2xl:m-20">
    <!-- Popup message alert if save is not possible (Evaluation in progress on this template) -->
    <EvalInProgress
      :evaluation-in-progress="evaluationInProgress"
      @massAssignation="displayAssignTemplate()"
      @showPreview="showPreview = true"
    />
    <!-- END Popup message alert -->

    <mass-template-assignation
      :opened="massAssignation"
      @close="massAssignation = false"
      :template="massAssignationTemplate"
    />

    <!-- BEGIN Popup confirm deactivate template -->
    <deactivate-template-popup
      :confirm-deactivate-template="confirmDeactivateTemplate"
      :template-name-to-deactivate="templateNameToDeactivate"
      :list-assigned-users-template="listAssignedUsersTemplate"
      :template-page-to-assign-after-delete="templatePageToAssignAfterDelete"
      @confirm_deactivate_template="
        (templatePageToAssignAfterDelete) => {
          confirm_deactivate_template(templatePageToAssignAfterDelete);
        }
      "
      @close="confirmDeactivateTemplate = -1"
    />
    <!-- END Popup confirm deactivate template -->

    <!-- BEGIN Popup confirm activate template -->
    <activate-template-popup
      :confirm-activate-template="confirmActivateTemplate"
      :template-name-to-deactivate="templateNameToDeactivate"
      @confirm_activate_template="confirm_activate_template()"
      @close="confirmActivateTemplate = -1"
    />
    <!-- END Popup confirm activate template -->

    <!-- Popup modal preview -->
    <popup
      :opened="showPreview"
      @close="showPreview = false"
    >
      <div>
        <h3 class="my-10 w-full">
          {{ infosPage.libelle_template }}
        </h3>
        <br>

        <h6 class="mx-15 2xl:mx-20 mb-10 text-gray-600">
          Cette page est un apercu interactif, vous pouvez modifier les valeurs
          des champs sans que cela ne se répercute sur le modèle de page
        </h6>
        <!-- Content modal -->
        <div>
          <!-- BEGIN Button to add a "langue" -->
          <div
            class="w-max-content w-max cursor-pointer flex items-center mx-15 2xl:mx-20 mb-5"
          >
            <span class="plus-button 2xl:h-10 2xl:w-10">
              <icon name="plus" />
            </span>
            <span class="text-base text-gray-600 ml-4 flex-initial">
              <div>Ajouter une langue</div>
              <div class="text-sm font-light">(Bouton non fonctionnel)</div>
            </span>
          </div>
          <!-- END Button to add a "langue" -->

          <div
            class="w-max-content w-max text-lg text-gray-600 h-16 lg:h-24 2xl:h-32 font-normal grid grid-cols-12 gap-x-4 place-content-center mt-5"
          >
            <div class="col-start-2 lg:col-start-2 col-span-6 lg:col-span-2">
              Langue
            </div>
            <div class="hidden lg:inline-block col-span-2">
              Comprendre
            </div>
            <div class="hidden lg:inline-block col-span-4">
              Parler
            </div>
            <div class="hidden lg:inline-block col-span-2">
              Ecrire
            </div>
            <div class="col-span-5 lg:col-span-1 -ml-5">
              Global
            </div>
          </div>

          <!-- BEGIN example langue anglais -->
          <div class="odd:bg-indigo-100 odd:bg-opacity-50">
            <!-- BEGIN Informations on accordion -->
            <div
              class="h-16 lg:h-24 2xl:h-32 hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center cursor-pointer"
              :class="{
                'bg-indigo-200 border-l-2 border-indigo-600':
                  langueDisplayed == 0,
              }"
              @click="displayLangue(0)"
            >
              <icon
                class="text-pink-600 col-span-1 place-self-center transform transition-transform ease-in-out duration-300"
                :class="{ 'rotate-90': langueDisplayed == 0 }"
                name="chevron-right"
              />
              <div
                class="col-span-6 lg:col-span-2 text-base text-indigo-600 font-normal flex items-center overflow-y-hidden"
              >
                <!-- Langue -->
                Anglais
              </div>
              <div
                class="hidden lg:inline-block col-span-2 text-base font-normal place-self-center justify-self-start"
              >
                <!-- Comprendre -->
                <div>Ecouter : <span class="text-pink-600">A1</span></div>
                <div>Lire : <span class="text-pink-600">A1</span></div>
              </div>
              <div
                class="hidden lg:inline-block col-span-4 text-base font-normal place-self-center justify-self-start"
              >
                <!-- Parler -->
                <div>
                  Prendre part à une conversation :
                  <span class="text-pink-600">A2</span>
                </div>
                <div>
                  S’exprimer oralement en continu :
                  <span class="text-pink-600">B1</span>
                </div>
              </div>
              <div
                class="hidden lg:inline-block col-span-2 text-base font-normal place-self-center justify-self-start"
              >
                <!-- Ecrire -->
                <div>Ecrire : <span class="text-pink-600">A1</span></div>
              </div>
              <div
                class="col-span-5 lg:col-span-1 text-base text-indigo-600 font-normal place-self-center mr-15 2xl:mr-20"
              >
                <!-- Global -->
                A2
              </div>
            </div>
            <!-- END Informations on accordion -->
            <transition
              enter-active-class="ease-out duration-300"
              enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enter-to-class="opacity-100 translate-y-0 sm:scale-100"
              leave-active-class="ease-in duration-200"
              leave-class="opacity-100 translate-y-0 sm:scale-100"
              leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <!-- BEGIN Form content -->

              <div
                v-if="langueDisplayed == 0"
                class="bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
              >
                <div
                  v-for="(field, jndex) in templateContent"
                  :key="jndex"
                  class="col-span-full lg:col-span-6 flex"
                  :class="{ 'lg:col-start-1': jndex == 1 }"
                >
                  <!-- use $set function to be reactive with form watch property -->
                  <input-text
                    v-if="field.type == 'text' && jndex == 0"
                    :libelle="field.libelle"
                    value="Anglais"
                  />
                  <input-select
                    v-else-if="field.type == 'multi'"
                    :name="
                      field.libelle
                        .toLowerCase()
                        .replace(' ', '_')
                        .replace('\'', '') + indexLangue
                    "
                    :libelle="field.libelle"
                    :datas="[
                      { value: 'A1' },
                      { value: 'A2' },
                      { value: 'B1' },
                      { value: 'B2' },
                      { value: 'C1' },
                      { value: 'C2' },
                      { value: 'D1' },
                      { value: 'D2' },
                    ]"
                  />
                </div>
                <!-- BEGIN button to delete a langue -->
                <div
                  class="col-span-full lg:col-start-1 lg:col-span-3 w-max-content w-max cursor-pointer flex text-gray-600 items-center"
                >
                  <span class="minus-button 2xl:h-10 2xl:w-10 2xl:mt-2">
                    <icon name="close" />
                  </span>
                  <span class="text-base ml-3">
                    <div>Supprimer cette langue</div>
                    <div class="text-sm font-light">
                      (Bouton non fonctionnel)
                    </div>
                  </span>
                </div>
                <!-- END button to delete an langue -->
              </div>
              <!-- END Form content -->
            </transition>
          </div>
          <!-- END example langue anglais -->
          <!-- BEGIN example langue Espagnol -->
          <div class="odd:bg-indigo-100 odd:bg-opacity-50">
            <!-- BEGIN Informations on accordion -->
            <div
              class="h-16 lg:h-24 2xl:h-32 hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center cursor-pointer"
              :class="{
                'bg-indigo-200 border-l-2 border-indigo-600':
                  langueDisplayed == 0,
              }"
              @click="displayLangue(0)"
            >
              <icon
                class="text-pink-600 col-span-1 place-self-center transform transition-transform ease-in-out duration-300"
                :class="{ 'rotate-90': langueDisplayed == 0 }"
                name="chevron-right"
              />
              <div
                class="col-span-6 lg:col-span-2 text-base text-indigo-600 font-normal flex items-center overflow-y-hidden"
              >
                <!-- Langue -->
                Espagnol
              </div>
              <div
                class="hidden lg:inline-block col-span-2 text-base font-normal place-self-center justify-self-start"
              >
                <!-- Comprendre -->
                <div>Ecouter : <span class="text-pink-600">A1</span></div>
                <div>Lire : <span class="text-pink-600">C2</span></div>
              </div>
              <div
                class="hidden lg:inline-block col-span-4 text-base font-normal place-self-center justify-self-start"
              >
                <!-- Parler -->
                <div>
                  Prendre part à une conversation :
                  <span class="text-pink-600">C2</span>
                </div>
                <div>
                  S’exprimer oralement en continu :
                  <span class="text-pink-600">D1</span>
                </div>
              </div>
              <div
                class="hidden lg:inline-block col-span-2 text-base font-normal place-self-center justify-self-start"
              >
                <!-- Ecrire -->
                <div>Ecrire : <span class="text-pink-600">A2</span></div>
              </div>
              <div
                class="col-span-5 lg:col-span-1 text-base text-indigo-600 font-normal place-self-center mr-15 2xl:mr-20"
              >
                <!-- Global -->
                B2
              </div>
            </div>
            <!-- END Informations on accordion -->
            <transition
              enter-active-class="ease-out duration-300"
              enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enter-to-class="opacity-100 translate-y-0 sm:scale-100"
              leave-active-class="ease-in duration-200"
              leave-class="opacity-100 translate-y-0 sm:scale-100"
              leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <!-- BEGIN Form content -->

              <div
                v-if="langueDisplayed == 0"
                class="bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
              >
                <div
                  v-for="(field, jndex) in templateContent"
                  :key="jndex"
                  class="col-span-full lg:col-span-6 flex"
                  :class="{ 'lg:col-start-1': jndex == 1 }"
                >
                  <!-- use $set function to be reactive with form watch property -->
                  <input-text
                    v-if="field.type == 'text' && jndex == 0"
                    :libelle="field.libelle"
                    value="Espagnol"
                  />
                  <input-select
                    v-else-if="field.type == 'multi'"
                    :name="
                      field.libelle
                        .toLowerCase()
                        .replace(' ', '_')
                        .replace('\'', '') + indexLangue
                    "
                    :libelle="field.libelle"
                    :datas="[
                      { value: 'A1' },
                      { value: 'A2' },
                      { value: 'B1' },
                      { value: 'B2' },
                      { value: 'C1' },
                      { value: 'C2' },
                      { value: 'D1' },
                      { value: 'D2' },
                    ]"
                  />
                </div>
                <!-- BEGIN button to delete a langue -->
                <div
                  class="col-span-full lg:col-start-1 lg:col-span-3 w-max-content w-max cursor-pointer flex text-gray-600 items-center"
                >
                  <span class="minus-button 2xl:h-10 2xl:w-10 2xl:mt-2">
                    <icon name="close" />
                  </span>
                  <span class="text-base ml-3">
                    <div>Supprimer cette langue</div>
                    <div class="text-sm font-light">
                      (Bouton non fonctionnel)
                    </div>
                  </span>
                </div>
                <!-- END button to delete an langue -->
              </div>
              <!-- END Form content -->
            </transition>
          </div>
          <!-- END example langue Espagnol -->
        </div>
        <!-- END Content modal -->
      </div>
    </popup>
    <!-- END Popup modal preview -->

    <!-- Title -->
    <div class="mb-5 md:mb-15 2xl:mb-20">
      <h3>
        {{ this.infosPage.libelle_template }}
      </h3>
    </div>
    <!-- END Title -->

    <!-- BEGIN Bloc action buttons -->
    <list-buttons
      :evaluation-in-progress="evaluationInProgress"
      :is-active="infosPage.is_active"
      @preview="
        () => {
          showPreview = true;
        }
      "
      @deactivateTemplate="displayConfirmDeactivateTemplate()"
      @activateTemplate="displayConfirmActivateTemplate()"
      @assignTemplate="displayAssignTemplate()"
      :can-delete="false"
    />
    <!-- END Bloc action buttons -->

    <!-- Custom content -->
    <div class="mx-15">
      <!-- Contenu de la partie personnalisable -->
      <h3 class="text-lg text-gray-600">
        Le référentiel Européen des langues n'est pas modifiable.<br>
        Vous pouvez simplement
        <span v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER)">activer ou désactiver</span><span v-else>visualiser</span> le modèle de page.
      </h3>
      <div class="my-15 flex justify-center">
        <illustration name="notAllowed" />
      </div>
    </div>
    <!-- END Custom content -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import InputText from '../../components/Inputs/InputText';
import InputSelect from '../../components/Inputs/InputSelect';

import ActionButton from '../../components/ActionButton';
import ListButtons from './../../components/Templates/listButtons.vue';

import Icon from '../../components/Icon';
import Illustration from '../../components/Illustration';
import Popup from '../../components/Popup';

import clickOutside from 'vue-click-outside';

import DeactivateTemplatePopup from './../../components/Templates/DeactivateTemplatePopup';
import ActivateTemplatePopup from './../../components/Templates/ActivateTemplatePopup';

import Constants from './../../constants';
import EvalInProgress from './EvalInProgress.vue';
import MassTemplateAssignation from './popups/MassTemplateAssignation.vue';

export default {
  components: {
    EvalInProgress,
    MassTemplateAssignation,
    InputText,
    InputSelect,
    Icon,
    ActionButton,
    Popup,
    Illustration,
    ListButtons,
    DeactivateTemplatePopup,
    ActivateTemplatePopup,
  },

  data() {
    return {
      confirmDeactivateTemplate: -1,
      confirmActivateTemplate: -1,
      editName: false,
      showPreview: false,
      langueDisplayed: -1,
      templateNameToDeactivate: '',
      constants: Constants,
      massAssignation: false,
      massAssignationTemplate: {},
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      save_datas: 'template/save_datas',
      switchState: 'template/switchState',
    }),
    ...mapMutations({
      SET_TEMPLATEVERSIONS: 'template/SET_TEMPLATEVERSIONS',
      SET_TEMPLATECONTENT: 'template/SET_TEMPLATECONTENT',
      SET_LIBELLE_TEMPLATE: 'template/SET_LIBELLE_TEMPLATE',
      SET_NAME_TEMPLATE_IN_LIST: 'template/SET_NAME_TEMPLATE_IN_LIST',
      SET_ISACTIVE: 'template/SET_ISACTIVE',
      SET_MESSAGEHEADER: 'template/SET_MESSAGEHEADER',
    }),
    switch_active(state) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER)
      ) {
        if (state) {
          this.SET_ISACTIVE(state);
          this.save_datas('Modèle de page activé');
        } else {
          if (
            this.listPageTemplates.filter(
              (t) => t.page_id == this.infosPage.id_page && t.is_active == 1
            ).length > 1
          ) {
            this.SET_ISACTIVE(state);
            this.save_datas('Modèle de page désactivé');
          } else {
            this.SET_MESSAGEHEADER({
              type: 'KO',
              msg: 'Vous ne pouvez pas désactiver tous les modèles d\'une même page',
            });
            setTimeout(() => {
              this.SET_MESSAGEHEADER({ type: '', msg: '' });
            }, 6200);
          }
        }
      }
    },

    displayAssignTemplate() {
      this.massAssignationTemplate = {
        id: this.infosPage.id_template,
        name: this.infosPage.libelle_template,
        page_id: this.infosPage.id_page
      };
      this.massAssignation = true;
    },

    editTemplateName() {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.editName = true;
      }
    },
    save_name() {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.SET_NAME_TEMPLATE_IN_LIST([
          this.infosPage.id_template,
          this.infosPage.libelle_template,
        ]);
        this.editName = false;
      }
    },
    displayLangue(indexLangue) {
      if (this.langueDisplayed == indexLangue) {
        this.langueDisplayed = -1;
      } else {
        this.langueDisplayed = indexLangue;
      }
    },
    displayConfirmDeactivateTemplate() {
      if (
        this.templatePageToAssignAfterDelete == null ||
        this.templatePageToAssignAfterDelete == undefined
      ) {
        this.SET_MESSAGEHEADER({
          type: 'error',
          msg: 'Vous ne pouvez pas désactiver le dernier modèle de ce type',
        });
        setTimeout(() => {
          this.SET_MESSAGEHEADER(null);
        }, 3000);
        return;
      }

      if (this.listAssignedUsersTemplate.length == 0) {
        this.confirmDeactivateTemplate = 0;
      }
      if (this.listAssignedUsersTemplate.length > 0) {
        this.confirmDeactivateTemplate = 2;
      }

      this.templateNameToDeactivate = this.infosPage.libelle_template;
    },

    displayConfirmActivateTemplate() {
      this.confirmActivateTemplate = 0;
      this.templateNameToDeactivate = this.infosPage.libelle_template;
    },

    confirm_deactivate_template(templateToReplace = null) {
      this.switchState({
        state: !this.infosPage.is_active,
        newTemplateToAssign: templateToReplace,
      });
      this.confirmDeactivateTemplate = 1;
    },

    confirm_activate_template() {
      this.switchState({
        state: !this.infosPage.is_active,
        newTemplateToAssign: null,
      });
      this.confirmActivateTemplate = 1;
    },
  },
  computed: {
    ...mapGetters({
      infosPage: 'template/infosPage',
      listPageTemplates: 'template/listPageTemplates',
      templateVersions: 'template/templateVersions',
      templateContent: 'template/templateContent',
      evaluationInProgress: 'template/evaluationInProgress',
      listAssignedUsersTemplate: 'template/listAssignedUsersTemplate',
    }),

    templatePageToAssignAfterDelete() {
      let nextPageTemplate = this.listPageTemplates.filter(
        (t) =>
          t.page_name == this.infosPage.name_page &&
          t.id != this.infosPage.id_template &&
          t.is_active == 1
      );
      return nextPageTemplate.length > 0 ? nextPageTemplate[0] : null;
    },
  },
  directives: {
    clickOutside,
  },
};
</script>